(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var splideEl = document.getElementById('splide-marquee');
  if (splideEl && window.Splide && window.splide.Extensions) {
    new Splide(splideEl, {
      type: 'loop',
      autoWidth: true,
      drag: false,
      arrows: false,
      pagination: false,
      focus: 'center',
      gap: '10px',
      perPage: 4,
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false
      },
      breakpoints: {
        1440: { perPage: 3 },
        1023: { perPage: 2 },
        480: { perPage: 1, gap: '2rem' }
      }
    }).mount(window.splide.Extensions);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["counter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const countdownEl = document.getElementById('countdown-states');
    const countdownDays = parseInt(countdownEl.dataset.countdownDays, 10) || 0;

    let targetDate = localStorage.getItem('countdownTarget');
    if (targetDate) {
      targetDate = new Date(targetDate);
    } else {
      targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + countdownDays);
      localStorage.setItem('countdownTarget', targetDate);
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        countdownEl.innerHTML = "<div class='title'>Launched!</div>";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      document.getElementById('days').textContent = String(days).padStart(2, '0');
      document.getElementById('hours').textContent = String(hours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
      document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  new Splide('#image-carousel', {
    type: 'loop',
    arrows: false,
    autoplay: true,
    interval: 3000,
  }).mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const discountInput = document.getElementById('discount-code');
    const message = document.getElementById('discount-message');

    function applyDiscount() {
      const code = discountInput.value.trim();

      if (!code) {
        message.style.color = 'red';
        message.textContent = 'Please enter a discount code.';
        message.style.display = 'block';
        return;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: '', attributes: { discount: code } }),
      })
        .then((response) => response.json())
        .then((data) => {
          window.location.href = `/discount/${code}?redirect=/cart`;
        })
        .catch((error) => {
          message.style.color = 'red';
          message.textContent = 'Invalid discount code.';
          message.style.display = 'block';
          console.error(error);
        });
    }

    discountInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount();
      }
    });

    discountInput.addEventListener('input', function () {
      message.style.display = 'none';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const inputForm = document.querySelector('.product__info-container .product-form__input');
  const cartBtn = document.querySelector('.product__info-container .cart-btn');
  const shareBtn = document.querySelector('.product__info-container .share-button');
  const wishBtn = document.querySelector('.product__info-container .wishlist-btn');

  if (inputForm && cartBtn && shareBtn && wishBtn) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('main-add-to-btn');

    inputForm.parentNode.insertBefore(wrapper, inputForm);
    wrapper.appendChild(inputForm);

    // Detect mobile screen
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (isMobile) {
      // Mobile order
      wrapper.appendChild(wishBtn);
      wrapper.appendChild(shareBtn);
      wrapper.appendChild(cartBtn);
    } else {
      // Desktop order
      wrapper.appendChild(cartBtn);
      wrapper.appendChild(wishBtn);
      wrapper.appendChild(shareBtn);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poke-faq"] && !Shopify.designMode) return;
  try {
    
  const faqs = document.querySelectorAll('.cf-cu-poke-faq .faq-container .faq-item');

  faqs.forEach((faq) => {
    const question = faq.querySelector('.faq-question');
    const answer = faq.querySelector('.faq-answer');
    const icon = faq.querySelector('.icon');

    if (faq.classList.contains('active')) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      icon.textContent = '−';
    }

    question.addEventListener('click', () => {
      const isActive = faq.classList.contains('active');

      faqs.forEach((item) => {
        item.classList.remove('active');
        item.querySelector('.faq-answer').style.maxHeight = null;
        item.querySelector('.icon').textContent = '＋';
      });

      if (!isActive) {
        faq.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        icon.textContent = '−';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
